<template>
    <button @click="clickAction" :class="{ 'is-disabled': isLoading }" class="btn btn-lg btn-primary btn-block">
        <span v-show="!isLoading"><i class="fa fa-lg fa-lg fa-save"></i> {{ text }}</span>
        <img v-show="isLoading" height="22px" :src="require('@/assets/img/loader.svg')">
    </button>
</template>

<script>
export default {
    props: ['text', 'isLoading', 'clickAction'],
}
</script>
